<template>
  <form @submit.prevent="saveFacility" ref="facilityEditForm">
    <div class="modal" tabindex="-1" role="dialog" backdrop="static" id="editFacilityModal" @keyup.esc="onEsc($event)">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header header">
            <h3 class="modal-title"><span v-if="action === 'add'">{{ $t('editFacilityModal.titleAdd') }}</span><span v-if="action === 'edit'">{{ $t('editFacilityModal.titleEdit') }}</span></h3>
            <button type="button" class="btn-close btn-close-white" @click="close" aria-label="Close">

            </button>
          </div>
          <div class="modal-body">
            <div class="form">
              <div v-show="errorMessage" class="alert alert-danger failed">{{ errorMessage }}</div>
              <div class="form-group">
                <label for="organizationName">{{ $t('editFacilityModal.organizationName') }}</label>
                <select v-if="canMoveFacility" id="organizationSelect" class="form-select" v-model="targetOrganizationId">
                  <option v-for="organization in organizationOptions" :key="organization.id" :value="organization.id">{{ organization.name }} ({{ organization.code }})</option>
                </select>
                <div v-else id="organizationName" class="blue-text">{{ selectedOrganization.name }}</div>
                <div v-if="organizationChanged" class="alert alert-warning mt-2">{{ $t('editFacilityModal.organizationMoveWarning', { name: targetOrganizationName }) }}</div>
              </div>
              <div class="form-group">
                <label for="nameInput">{{ $t('editFacilityModal.nameInput') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': v$.facility.name.$dirty && v$.facility.name.$error }" id="nameInput" v-model.trim="facility.name" :placeholder="$t('editFacilityModal.namePlaceholder')" maxlength="255">
                <div class="invalid-feedback" v-if="v$.facility.name.$dirty">
                  <div class="error" v-if="!v$.facility.name.required">{{ $t('editFacilityModal.nameRequired') }}</div>
                  <div class="error" v-if="!v$.facility.name.minLength">{{ $t('editFacilityModal.nameMinLength', { min: v$.facility.name.$params.minLength.min }) }}</div>
                  <div class="error" v-if="!v$.facility.name.maxLength">{{ $t('editFacilityModal.nameMaxLength', { max: v$.facility.name.$params.maxLength.max }) }}</div>
                </div>
              </div>
              <div class="form-group">
                <label for="descriptionInput">{{ $t('editFacilityModal.descriptionInput') }}</label>
                <textarea v-autoresize rows="1" class="form-control" :class="{ 'is-invalid': v$.facility.description.$dirty && v$.facility.description.$error }" id="descriptionInput" v-model.trim="facility.description" :placeholder="$t('editFacilityModal.descriptionPlaceholder')" maxlength="255"></textarea>
                <div class="invalid-feedback" v-if="v$.facility.description.$dirty">
                  <div class="error" v-if="!v$.facility.description.maxLength">{{ $t('editFacilityModal.descriptionMaxLength', { max: v$.facility.description.$params.maxLength.max }) }}</div>
                </div>
              </div>
              <div class="form-group">
                <label for="geolatitudeInput">{{ $t('editFacilityModal.geolatitudeInput') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': v$.facility.geolatitude.$dirty && v$.facility.geolatitude.$error }" id="geolatitudeInput" v-model="facility.geolatitude" :placeholder="$t('editFacilityModal.geolatitudePlaceholder')">
                <div class="invalid-feedback" v-if="v$.facility.geolatitude.$dirty">
                  <div class="error" v-if="!v$.facility.geolatitude.decimal">{{ $t('editFacilityModal.geolatitudeValue') }}</div>
                  <div class="error" v-if="!v$.facility.geolatitude.minValue">{{ $t('editFacilityModal.geolatitudeValue') }}</div>
                  <div class="error" v-if="!v$.facility.geolatitude.maxValue">{{ $t('editFacilityModal.geolatitudeValue') }}</div>
                </div>
              </div>
              <div class="form-group">
                <label for="geolongitudeInput">{{ $t('editFacilityModal.geolongitudeInput') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': v$.facility.geolongitude.$dirty && v$.facility.geolongitude.$error }" id="geolongitudeInput" v-model="facility.geolongitude" :placeholder="$t('editFacilityModal.geolongitudePlaceholder')">
                <div class="invalid-feedback" v-if="v$.facility.geolongitude.$dirty">
                  <div class="error" v-if="!v$.facility.geolongitude.decimal">{{ $t('editFacilityModal.geolongitudeValue') }}</div>
                  <div class="error" v-if="!v$.facility.geolongitude.minValue">{{ $t('editFacilityModal.geolongitudeValue') }}</div>
                  <div class="error" v-if="!v$.facility.geolongitude.maxValue">{{ $t('editFacilityModal.geolongitudeValue') }}</div>
                </div>
              </div>
              <div v-if="facility.geolatitude && facility.geolongitude" class="form-group">
                <label><a :href="createMapLink" target="_blank" >{{ $t('editFacilityModal.linkToMap') }}</a></label>
              </div>
              <div class="form-group">
                <label for="externalidInput">{{ $t('editFacilityModal.externalidInput') }}</label>
                <textarea v-autoresize rows="1" class="form-control" :class="{ 'is-invalid': v$.facility.externalid.$dirty && v$.facility.externalid.$error }" id="externalidInput" v-model.trim="facility.externalid" :placeholder="$t('editFacilityModal.externalidPlaceholder')" maxlength="64"></textarea>
                <div class="invalid-feedback" v-if="v$.facility.externalid.$dirty">
                  <div class="error" v-if="!v$.facility.externalid.maxLength">{{ $t('editFacilityModal.externalidMaxLength', { max: v$.facility.externalid.$params.maxLength.max }) }}</div>
                </div>
              </div>
               <div class="form-group" v-if="!extra.fluks">
                 <button type="button" class="btn btn-secondary" @click="addFluksData">{{ $t('editFacilityModal.buttonAddDomus') }}</button>
               </div>
              <div class="form-group" v-if="extra.fluks">
                <label for="fluksObjektNummerInput">{{ $t('editFacilityModal.fluksObjektNummerInput') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': v$.extra.fluks.ObjektNummer.$dirty && v$.extra.fluks.ObjektNummer.$error }" id="fluksObjektNummerInput" v-model.trim="extra.fluks.ObjektNummer" :placeholder="$t('editFacilityModal.fluksObjektNummerPlaceholder')" maxlength="20" />
                <div class="invalid-feedback" v-if="v$.extra.fluks.ObjektNummer.$dirty">
                  <div class="error" v-if="!v$.extra.fluks.ObjektNummer.decimal">{{ $t('editFacilityModal.fluksObjektNummerValue') }}</div>
                  <div class="error" v-if="!v$.extra.fluks.ObjektNummer.maxLength">{{ $t('editFacilityModal.fluksObjektNummerMaxLength', { max: v$.extra.fluks.ObjektNummer.$params.maxLength.max }) }}</div>
                </div>
                <label for="fluksKreisNummerInput">{{ $t('editFacilityModal.fluksKreisNummerInput') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': v$.extra.fluks.KreisNummer.$dirty && v$.extra.fluks.KreisNummer.$error }" id="fluksKreisNummerInput" v-model.trim="extra.fluks.KreisNummer" :placeholder="$t('editFacilityModal.fluksKreisNummerPlaceholder')" maxlength="20" />
                <div class="invalid-feedback" v-if="v$.extra.fluks.KreisNummer.$dirty">
                  <div class="error" v-if="!v$.extra.fluks.KreisNummer.decimal">{{ $t('editFacilityModal.fluksKreisNummerValue') }}</div>
                  <div class="error" v-if="!v$.extra.fluks.KreisNummer.maxLength">{{ $t('editFacilityModal.fluksKreisNummerMaxLength', { max: v$.extra.fluks.KreisNummer.$params.maxLength.max }) }}</div>
                </div>
                <label for="fluksMandantenNummerInput">{{ $t('editFacilityModal.fluksMandantenNummerInput') }}</label>
                <input type="text" class="form-control" :class="{ 'is-invalid': v$.extra.fluks.MandantenNummer.$dirty && v$.extra.fluks.MandantenNummer.$error }" id="fluksMandantenNummerInput" v-model.trim="extra.fluks.MandantenNummer" :placeholder="$t('editFacilityModal.fluksMandantenNummerPlaceholder')" maxlength="20" />
                <div class="invalid-feedback" v-if="v$.extra.fluks.MandantenNummer.$dirty">
                  <div class="error" v-if="!v$.extra.fluks.MandantenNummer.decimal">{{ $t('editFacilityModal.fluksMandantenNummerValue') }}</div>
                  <div class="error" v-if="!v$.extra.fluks.MandantenNummer.maxLength">{{ $t('editFacilityModal.fluksMandantenNummerMaxLength', { max: v$.extra.fluks.MandantenNummer.$params.maxLength.max }) }}</div>
                </div>
              </div>
                <div class="form-group">
                  <label for="facilityTypeInput">{{ $t('editFacilityModal.facilityTypeInput') }}</label>
                  <select class="form-control" id="facilityTypeInput" v-model="facility.type" @change="checkType">
                    <option v-for="type in facilityTypeList" :value="type" :key="type">
                      {{ facilityTypeString(type) }}
                    </option>
                  </select>
                </div>
                <div class="form-group" v-if="action === 'edit'">
                  <label><strong>{{ $t('editFacilityModal.emissionDefaultsTitle') }}</strong></label>
                  <div v-for="(typeLabel, typeKey) in emissionSensorTypes" :key="typeKey" style="margin-top: 8px; border: 1px solid #dee2e6; border-radius: 4px; padding: 8px;">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="small font-weight-bold">{{ $t('editFacilityModal.emission' + capitalize(typeKey)) }}</span>
                      <button type="button" class="btn btn-outline-primary btn-sm" @click="openAddEmission(typeKey)">+ {{ $t('editFacilityModal.emissionAdd') }}</button>
                    </div>
                    <!-- Coverage warning: sensors of this medium but no active emission, or daily totals without emission -->
                    <div v-if="coverageGap(typeKey)" class="coverage-warning small mt-1">
                      <div v-if="!coverageGap(typeKey).activeEmission">⚠ {{ $t('editFacilityModal.coverageNoActive', { sensors: coverageGap(typeKey).sensors }) }}</div>
                      <div v-if="coverageUnassigned(typeKey) > 0">⚠ {{ $t('editFacilityModal.coverageUnassigned', { count: coverageUnassigned(typeKey), period: coveragePeriod(typeKey) }) }}</div>
                      <div v-if="isAdmin" class="mt-1">
                        <button type="button" class="btn btn-warning btn-sm" @click="fixCoverage(typeKey)" :disabled="coverageFixing === typeKey">
                          <span v-if="coverageFixing === typeKey" class="spinner-border spinner-border-sm"></span>
                          {{ coverageGap(typeKey).activeEmission ? $t('editFacilityModal.coverageFixStamp') : $t('editFacilityModal.coverageFixCreate') }}
                        </button>
                      </div>
                      <div v-else class="text-muted">{{ $t('editFacilityModal.coverageCaretakerHint') }}</div>
                    </div>
                    <!-- outside the warning: after a successful fix the warning disappears, the confirmation stays -->
                    <div v-if="coverageMessage[typeKey]" class="small mt-1" :class="coverageMessage[typeKey].ok ? 'text-success' : 'text-danger'">{{ coverageMessage[typeKey].text }}</div>
                    <div v-if="activeEmissionForType(typeKey)" class="small mt-1 emission-active">
                      <div class="emission-row"><span class="emission-label">CO2e</span><span>{{ activeEmissionForType(typeKey).co2e }} kg/{{ emissionUnit(typeKey) }}</span></div>
                      <div class="emission-row"><span class="emission-label">{{ $t('editFacilityModal.emissionBasePrice') }}</span><span>{{ formatPrice(activeEmissionForType(typeKey).basePrice) }} €/{{ $t('editFacilityModal.emissionMonth') }}</span></div>
                      <div class="emission-row"><span class="emission-label">{{ $t('editFacilityModal.emissionUnitPrice') }}</span><span>{{ formatPrice(activeEmissionForType(typeKey).unitPrice, 4) }} €/{{ emissionUnit(typeKey) }}</span></div>
                      <div class="emission-row"><span class="emission-label">{{ $t('editFacilityModal.emissionValidity') }}</span><span>{{ activeEmissionForType(typeKey).validFrom ? formatEmissionDate(activeEmissionForType(typeKey).validFrom) : '?' }} – {{ activeEmissionForType(typeKey).validTill ? formatEmissionDate(activeEmissionForType(typeKey).validTill) : '∞' }}</span></div>
                      <div v-if="activeEmissionForType(typeKey).dynamic" class="emission-row"><span class="emission-label">{{ $t('editFacilityModal.emissionDynamic') }}</span><span>✓</span></div>
                      <div v-if="activeEmissionForType(typeKey).supplyContract" class="emission-row"><span class="emission-label">{{ $t('editFacilityModal.emissionSupplyContract') }}</span><span>{{ activeEmissionForType(typeKey).supplyContract.contractName }}<span v-if="activeEmissionForType(typeKey).supplyContract.companyName" class="text-muted"> ({{ activeEmissionForType(typeKey).supplyContract.companyName }})</span></span></div>
                      <div class="emission-row description-row">
                        <span class="emission-label">{{ $t('editFacilityModal.emissionDescription') }}</span>
                        <span v-if="!isEditingDescription(activeEmissionForType(typeKey).id)" class="description-value">
                          <span v-if="activeEmissionForType(typeKey).description">{{ activeEmissionForType(typeKey).description }}</span>
                          <span v-else class="text-muted">—</span>
                          <font-awesome-icon icon="edit" class="description-edit-icon" @click="startEditDescription(activeEmissionForType(typeKey))" :title="$t('editFacilityModal.emissionDescriptionEdit')" />
                        </span>
                        <span v-else class="description-edit">
                          <input type="text" class="form-control form-control-sm description-input" v-model="descEditState.value" maxlength="1024" @keyup.enter="saveDescriptionEdit" @keyup.esc="cancelEditDescription" />
                          <button type="button" class="btn btn-primary btn-sm description-btn" @click="saveDescriptionEdit" :disabled="descEditState.saving">{{ $t('editFacilityModal.emissionSave') }}</button>
                          <button type="button" class="btn btn-secondary btn-sm description-btn" @click="cancelEditDescription">{{ $t('editFacilityModal.close') }}</button>
                        </span>
                      </div>
                      <div v-if="descEditState && descEditState.errorMessage && descEditState.emissionId === activeEmissionForType(typeKey).id" class="small text-danger">{{ descEditState.errorMessage }}</div>
                    </div>
                    <div v-else class="small mt-1 text-muted">{{ $t('editFacilityModal.emissionNone') }}</div>
                    <!-- Historical entries -->
                    <div v-if="historicalEmissionsForType(typeKey).length > 0" class="emission-history mt-2">
                      <a href="#" class="small text-muted history-toggle" @click.prevent="toggleHistory(typeKey)">
                        <font-awesome-icon :icon="historyOpenForType === typeKey ? 'caret-down' : 'caret-right'" />
                        {{ historicalEmissionsForType(typeKey).length }} {{ $t('editFacilityModal.emissionHistory') }}
                      </a>
                      <div v-if="historyOpenForType === typeKey" class="emission-history-list mt-1">
                        <div v-for="em in historicalEmissionsForType(typeKey)" :key="em.id" class="emission-history-row small">
                          <div class="emission-history-summary">
                            <span class="emission-history-text">
                              <span class="text-muted">{{ em.validFrom ? formatEmissionDate(em.validFrom) : '?' }} – {{ em.validTill ? formatEmissionDate(em.validTill) : '∞' }}</span>
                              &nbsp;·&nbsp; {{ em.co2e }} kg/{{ emissionUnit(typeKey) }}
                              &nbsp;·&nbsp; {{ formatPrice(em.basePrice) }} €/{{ $t('editFacilityModal.emissionMonth') }}
                              &nbsp;+ {{ formatPrice(em.unitPrice, 4) }} €/{{ emissionUnit(typeKey) }}
                              <span v-if="em.supplyContract" class="text-muted">&nbsp;·&nbsp; {{ em.supplyContract.contractName }}</span>
                              <span v-if="emissionUsageCount(em.id) > 0" class="text-muted">&nbsp;·&nbsp; {{ $t('editFacilityModal.emissionInUse', { count: emissionUsageCount(em.id) }) }}</span>
                            </span>
                            <button
                              v-if="canDeleteEmission(em)"
                              type="button"
                              class="btn btn-link btn-sm emission-delete-btn"
                              @click="confirmDeleteEmission(em)"
                              :title="$t('editFacilityModal.emissionDelete')">
                              <font-awesome-icon icon="trash" />
                            </button>
                          </div>
                          <div class="description-row">
                            <span v-if="!isEditingDescription(em.id)" class="description-value">
                              <span v-if="em.description">{{ em.description }}</span>
                              <span v-else class="text-muted">—</span>
                              <font-awesome-icon icon="edit" class="description-edit-icon" @click="startEditDescription(em)" :title="$t('editFacilityModal.emissionDescriptionEdit')" />
                            </span>
                            <span v-else class="description-edit">
                              <input type="text" class="form-control form-control-sm description-input" v-model="descEditState.value" maxlength="1024" @keyup.enter="saveDescriptionEdit" @keyup.esc="cancelEditDescription" />
                              <button type="button" class="btn btn-primary btn-sm description-btn" @click="saveDescriptionEdit" :disabled="descEditState.saving">{{ $t('editFacilityModal.emissionSave') }}</button>
                              <button type="button" class="btn btn-secondary btn-sm description-btn" @click="cancelEditDescription">{{ $t('editFacilityModal.close') }}</button>
                            </span>
                          </div>
                          <div v-if="descEditState && descEditState.errorMessage && descEditState.emissionId === em.id" class="small text-danger">{{ descEditState.errorMessage }}</div>
                        </div>
                      </div>
                    </div>
                    <!-- Add emission form (inline) -->
                    <div v-if="addEmissionForm.typeKey === typeKey && addEmissionForm.context === 'facility'" class="mt-2" style="background:#f8f9fa; padding:8px; border-radius:4px;">
                      <div class="form-group mb-1">
                        <label class="small mb-0">{{ $t('editFacilityModal.emissionSupplyContract') }}</label>
                        <select class="form-control form-control-sm" v-model="addEmissionForm.supplyContractId" @change="prefillFromContract">
                          <option :value="null">– {{ $t('editFacilityModal.emissionManual') }} –</option>
                          <option v-for="sc in supplyContractsForType(typeKey)" :key="sc.id" :value="sc.id">{{ sc.contractName }}<span v-if="sc.companyName"> ({{ sc.companyName }})</span><template v-if="sc.isDefault"> · {{ $t('editFacilityModal.emissionStandard') }}</template></option>
                        </select>
                      </div>
                      <div v-if="typeKey === 'gas'" class="gas-unit mb-1">
                        <label class="small mb-0">{{ $t('editFacilityModal.gasInputUnit') }}</label>
                        <div class="btn-group btn-group-sm d-flex" role="group">
                          <button type="button" :class="addEmissionForm.gasInputUnit === 'm3' ? 'btn btn-primary' : 'btn btn-outline-secondary'" @click="addEmissionForm.gasInputUnit = 'm3'">{{ $t('editFacilityModal.gasPerCubicMeter') }}</button>
                          <button type="button" :class="addEmissionForm.gasInputUnit === 'kWh' ? 'btn btn-primary' : 'btn btn-outline-secondary'" @click="addEmissionForm.gasInputUnit = 'kWh'">{{ $t('editFacilityModal.gasPerKwh') }}</button>
                        </div>
                        <template v-if="addEmissionForm.gasInputUnit === 'kWh'">
                          <div class="form-row mt-1">
                            <div class="col-6 form-group mb-1">
                              <label class="small mb-0">{{ $t('editFacilityModal.gasCalorificValue') }} *</label>
                              <input type="text" inputmode="decimal" class="form-control form-control-sm" v-model="addEmissionForm.calorificValue" :placeholder="$t('editFacilityModal.gasExample', { value: '11,2' })">
                            </div>
                            <div class="col-6 form-group mb-1">
                              <label class="small mb-0">{{ $t('editFacilityModal.gasStateNumber') }} *</label>
                              <input type="text" inputmode="decimal" class="form-control form-control-sm" v-model="addEmissionForm.stateNumber" :placeholder="$t('editFacilityModal.gasExample', { value: '0,95' })">
                            </div>
                          </div>
                          <div class="small text-muted">{{ $t('editFacilityModal.gasConversionHint') }}</div>
                          <div v-if="gasConversionPreview" class="small">{{ gasConversionPreview }}</div>
                        </template>
                      </div>
                      <div class="form-row">
                        <div class="col-6 form-group mb-1">
                          <label class="small mb-0">CO2e (kg/{{ inputUnit(typeKey) }}) *</label>
                          <input type="number" step="0.0001" class="form-control form-control-sm" v-model="addEmissionForm.co2e">
                        </div>
                        <div class="col-6 form-group mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.emissionDescription') }}</label>
                          <input type="text" class="form-control form-control-sm" v-model="addEmissionForm.description" maxlength="255">
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-6 form-group mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.emissionBasePrice') }} (€/{{ $t('editFacilityModal.emissionMonth') }})</label>
                          <input type="number" step="0.01" class="form-control form-control-sm" v-model="addEmissionForm.basePrice">
                        </div>
                        <div class="col-6 form-group mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.emissionUnitPrice') }} (€/{{ inputUnit(typeKey) }})</label>
                          <input type="number" step="0.0001" class="form-control form-control-sm" v-model="addEmissionForm.unitPrice">
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-6 form-group mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.emissionValidFrom') }}</label>
                          <input type="date" class="form-control form-control-sm" v-model="addEmissionForm.validFrom">
                        </div>
                        <div class="col-6 form-group mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.emissionValidTill') }}</label>
                          <input type="date" class="form-control form-control-sm" v-model="addEmissionForm.validTill">
                        </div>
                      </div>
                      <div v-if="addEmissionForm.errorMessage" class="small text-danger mb-1">{{ addEmissionForm.errorMessage }}</div>
                      <button type="button" class="btn btn-primary btn-sm mr-1" @click="saveEmission" :disabled="!addEmissionForm.co2e">{{ $t('editFacilityModal.emissionSave') }}</button>
                      <button type="button" class="btn btn-secondary btn-sm" @click="closeAddEmission">{{ $t('editFacilityModal.close') }}</button>
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="isAdmin && action === 'edit'">
                  <label><strong>{{ $t('editFacilityModal.recalculateCo2Title') }}</strong></label>
                  <div class="form-row align-items-center" style="margin-top: 6px;">
                    <div class="col-5">
                      <label class="small">{{ $t('editFacilityModal.recalculateFrom') }}</label>
                      <input type="date" class="form-control form-control-sm" v-model="recalcFrom" @change="resetRecalcPanel">
                    </div>
                    <div class="col-5">
                      <label class="small">{{ $t('editFacilityModal.recalculateTo') }}</label>
                      <input type="date" class="form-control form-control-sm" v-model="recalcTo" @change="resetRecalcPanel">
                    </div>
                    <div class="col-2 d-flex align-items-end">
                      <button type="button" class="btn btn-secondary btn-sm" @click="loadRecalcEmissions" :disabled="!recalcFrom || !recalcTo">{{ $t('editFacilityModal.recalculateSelect') }}</button>
                    </div>
                  </div>

                  <!-- Emission preview panel -->
                  <div v-if="recalcShowPanel" style="margin-top: 10px; border: 1px solid #dee2e6; border-radius: 4px; padding: 10px;">
                    <div v-for="(sensorType, typeKey) in emissionSensorTypes" :key="typeKey" style="margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #f0f0f0;">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="small font-weight-bold">{{ $t('editFacilityModal.emission' + capitalize(typeKey)) }}</span>
                        <button type="button" class="btn btn-outline-primary btn-sm" @click="openAddEmission(typeKey, 'recalc')">+ {{ $t('editFacilityModal.emissionAdd') }}</button>
                      </div>
                      <div class="small mt-1">
                        <!-- Selected emission: click to open picker -->
                        <span v-if="recalcEmissionForType(typeKey)"
                              class="text-success" style="cursor:pointer; text-decoration:underline dotted;" @click="openRecalcPicker(typeKey)" :title="$t('editFacilityModal.recalculatePickerHint')">
                          &#10003; {{ recalcEmissionForType(typeKey).co2e }} kg/{{ emissionUnit(typeKey) }}
                          <span v-if="recalcEmissionForType(typeKey).description"> – {{ recalcEmissionForType(typeKey).description }}</span>
                          <span class="text-muted"> ({{ formatEmissionDate(recalcEmissionForType(typeKey).validFrom) }} – {{ recalcEmissionForType(typeKey).validTill ? formatEmissionDate(recalcEmissionForType(typeKey).validTill) : '∞' }})</span>
                          <span class="text-muted ml-1">&#9660;</span>
                        </span>
                        <!-- No selection yet but candidates exist: show picker button -->
                        <span v-else-if="recalcCandidatesForType(typeKey).length > 0"
                              class="text-primary" style="cursor:pointer;" @click="openRecalcPicker(typeKey)">
                          {{ $t('editFacilityModal.recalculateSelectEmission') }} &#9660;
                        </span>
                        <!-- No candidates at all -->
                        <span v-else class="text-warning">&#9888; {{ $t('editFacilityModal.recalculateNoEmission') }}</span>
                        <!-- Emission picker dropdown -->
                        <div v-if="recalcPickerTypeKey === typeKey" class="mt-1" style="background:#fff; border:1px solid #ced4da; border-radius:4px; padding:8px; position:relative; z-index:10;">
                          <div class="small font-weight-bold mb-1 text-muted">{{ $t('editFacilityModal.recalculatePickerTitle') }}</div>
                          <div v-for="em in recalcCandidatesForType(typeKey)" :key="em.id"
                               class="py-1 px-1 small"
                               style="cursor:pointer; border-bottom:1px solid #f0f0f0;"
                               :style="recalcEmissionsMap[typeKey] && recalcEmissionsMap[typeKey].id === em.id ? 'background:#e8f5e9;' : ''"
                               @click="selectRecalcEmission(typeKey, em)">
                            <span :class="recalcEmissionsMap[typeKey] && recalcEmissionsMap[typeKey].id === em.id ? 'text-success font-weight-bold' : ''">
                              {{ em.co2e }} kg/{{ emissionUnit(typeKey) }}
                              <span v-if="em.description"> – {{ em.description }}</span>
                              <span class="text-muted"> ({{ formatEmissionDate(em.validFrom) }} – {{ em.validTill ? formatEmissionDate(em.validTill) : '∞' }})</span>
                            </span>
                          </div>
                          <button type="button" class="btn btn-sm btn-secondary mt-2" @click="recalcPickerTypeKey = null">{{ $t('editFacilityModal.close') }}</button>
                        </div>
                      </div>
                      <!-- Inline add emission form for recalc context -->
                      <div v-if="addEmissionForm.typeKey === typeKey && addEmissionForm.context === 'recalc'" class="mt-2" style="background:#f8f9fa; padding:8px; border-radius:4px;">
                        <div class="form-group mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.emissionSupplyContract') }}</label>
                          <select class="form-control form-control-sm" v-model="addEmissionForm.supplyContractId" @change="prefillFromContract">
                            <option :value="null">– {{ $t('editFacilityModal.emissionManual') }} –</option>
                            <option v-for="sc in supplyContractsForType(typeKey)" :key="sc.id" :value="sc.id">{{ sc.contractName }}<span v-if="sc.companyName"> ({{ sc.companyName }})</span><template v-if="sc.isDefault"> · {{ $t('editFacilityModal.emissionStandard') }}</template></option>
                          </select>
                        </div>
                        <div v-if="typeKey === 'gas'" class="gas-unit mb-1">
                          <label class="small mb-0">{{ $t('editFacilityModal.gasInputUnit') }}</label>
                          <div class="btn-group btn-group-sm d-flex" role="group">
                            <button type="button" :class="addEmissionForm.gasInputUnit === 'm3' ? 'btn btn-primary' : 'btn btn-outline-secondary'" @click="addEmissionForm.gasInputUnit = 'm3'">{{ $t('editFacilityModal.gasPerCubicMeter') }}</button>
                            <button type="button" :class="addEmissionForm.gasInputUnit === 'kWh' ? 'btn btn-primary' : 'btn btn-outline-secondary'" @click="addEmissionForm.gasInputUnit = 'kWh'">{{ $t('editFacilityModal.gasPerKwh') }}</button>
                          </div>
                          <template v-if="addEmissionForm.gasInputUnit === 'kWh'">
                            <div class="form-row mt-1">
                              <div class="col-6 form-group mb-1">
                                <label class="small mb-0">{{ $t('editFacilityModal.gasCalorificValue') }} *</label>
                                <input type="text" inputmode="decimal" class="form-control form-control-sm" v-model="addEmissionForm.calorificValue" :placeholder="$t('editFacilityModal.gasExample', { value: '11,2' })">
                              </div>
                              <div class="col-6 form-group mb-1">
                                <label class="small mb-0">{{ $t('editFacilityModal.gasStateNumber') }} *</label>
                                <input type="text" inputmode="decimal" class="form-control form-control-sm" v-model="addEmissionForm.stateNumber" :placeholder="$t('editFacilityModal.gasExample', { value: '0,95' })">
                              </div>
                            </div>
                            <div class="small text-muted">{{ $t('editFacilityModal.gasConversionHint') }}</div>
                            <div v-if="gasConversionPreview" class="small">{{ gasConversionPreview }}</div>
                          </template>
                        </div>
                        <div class="form-row">
                          <div class="col-6 form-group mb-1">
                            <label class="small mb-0">CO2e (kg/{{ inputUnit(typeKey) }}) *</label>
                            <input type="number" step="0.0001" class="form-control form-control-sm" v-model="addEmissionForm.co2e">
                          </div>
                          <div class="col-6 form-group mb-1">
                            <label class="small mb-0">{{ $t('editFacilityModal.emissionDescription') }}</label>
                            <input type="text" class="form-control form-control-sm" v-model="addEmissionForm.description" maxlength="255">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-6 form-group mb-1">
                            <label class="small mb-0">{{ $t('editFacilityModal.emissionValidFrom') }}</label>
                            <input type="date" class="form-control form-control-sm" v-model="addEmissionForm.validFrom">
                          </div>
                          <div class="col-6 form-group mb-1">
                            <label class="small mb-0">{{ $t('editFacilityModal.emissionValidTill') }}</label>
                            <input type="date" class="form-control form-control-sm" v-model="addEmissionForm.validTill">
                          </div>
                        </div>
                        <div v-if="addEmissionForm.errorMessage" class="small text-danger mb-1">{{ addEmissionForm.errorMessage }}</div>
                        <button type="button" class="btn btn-primary btn-sm mr-1" @click="saveEmission" :disabled="!addEmissionForm.co2e">{{ $t('editFacilityModal.emissionSave') }}</button>
                        <button type="button" class="btn btn-secondary btn-sm" @click="closeAddEmission">{{ $t('editFacilityModal.close') }}</button>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-2">
                      <div v-if="recalcMessage" class="small" :class="recalcError ? 'text-danger' : 'text-success'">{{ recalcMessage }}</div>
                      <div v-else></div>
                      <button type="button" class="btn btn-warning btn-sm" @click="triggerRecalculate" :disabled="!hasAnyRecalcEmission || recalcLoading">
                        <span v-if="recalcLoading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        {{ $t('editFacilityModal.recalculateButton') }}
                      </button>
                    </div>
                  </div>
                </div>

<!--
                  <textarea-autosize rows="1" class="form-control" :class="{ 'is-invalid': v$.facility.type.$dirty && v$.facility.type.$error }" id="facilityTypeInput" v-model.trim="facility.type" :placeholder="$t('editFacilityModal.facilityTypePlaceholder')"/>

                  <div class="invalid-feedback" v-if="v$.facility.type.$dirty">
                    <div class="error" v-if="!v$.facility.type.maxLength">{{ $t('editFacilityModal.typeMaxLength', { max: v$.facility.type.$params.maxLength.max }) }}</div>
                  </div>
 -->
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary"><span v-if="action === 'add'">{{ $t('editFacilityModal.buttonAdd') }}</span><span v-if="action === 'edit'">{{ $t('editFacilityModal.buttonSave') }}</span></button>
            <button type="button" class="btn btn-secondary" @click="close">{{ $t('editFacilityModal.close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { Modal } from 'bootstrap'
import moment from 'moment'
import { required, minLength, maxLength, decimal, minValue, maxValue } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import ModalViewMixin from '@/mixins/ModalViewMixin.js'
import facilityService from '@/services/facilities'
import organizationService from '@/services/organizations'
import { kwhPerCubicMeter, perKwhToPerCubicMeter, conversionNote } from '@/utils/gas-conversion'
import coverageService from '@/services/emissionCoverage'
import { isGap as isCoverageGap, unassignedCount, defaultContractForType } from '@/utils/emission-coverage'

export default {
  setup () { return { v$: useVuelidate() } },
  name: 'EditFacilityModal',
  mixins: [ModalViewMixin],
  props: {
    selectedOrganization: {
      type: Object,
      required: true
    },
    selectedFacility: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      facility: {},
      // admin only: all organizations the facility may move to (build 321);
      // not taken from the store, FacilitiesPage keeps only the current one there
      organizationList: [],
      targetOrganizationId: null,
      facilityTypeList: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      errorMessage: '',
      extra: {},
      emissionSensorTypes: { power: 0, gas: 1, water: 2, heat: 3 },
      facilityEmissions: [],
      emissionUsage: {},
      facilityCoverage: [], // rows of /api/facilities/{id}/emissioncoverage
      coverageFixing: null, // typeKey while a fix runs
      coverageMessage: {}, // typeKey -> { ok, text }
      addEmissionForm: { typeKey: null, context: 'facility', supplyContractId: null, co2e: '', basePrice: '', unitPrice: '', description: '', validFrom: '', validTill: '', errorMessage: '', gasInputUnit: 'm3', calorificValue: '', stateNumber: '' },
      historyOpenForType: null,
      descEditState: null,
      recalcFrom: null,
      recalcTo: null,
      recalcMessage: '',
      recalcError: false,
      recalcShowPanel: false,
      recalcEmissionsMap: {},
      recalcAllEmissions: [],
      recalcPickerTypeKey: null,
      recalcLoading: false
    }
  },
  watch: {
    modalOpened () {
      /* eslint-disable no-console */
      console.log('modalOpened')
      this.$store.dispatch('getSupplyContracts')
      this.copyFacility()
      if (this.action === 'edit' && this.selectedFacility && this.selectedFacility.id) {
        this.loadFacilityEmissions()
        if (this.isAdmin) {
          this.loadOrganizationList()
        }
      }
      this.triggerFocus()
    }
  },
  validations: {
    extra: {
      fluks: {
        ObjektNummer: {
          decimal,
          maxLength: maxLength(20)
        },
        MandantenNummer: {
          decimal,
          maxLength: maxLength(20)
        },
        KreisNummer: {
          decimal,
          maxLength: maxLength(20)
        }
      }
    },
    facility: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(255)
      },
      description: {
        maxLength: maxLength(255)
      },
      geolatitude: {
        decimal,
        minValue: minValue(-90.0),
        maxValue: maxValue(90.0)
      },
      geolongitude: {
        decimal,
        minValue: minValue(-180.0),
        maxValue: maxValue(180.0)
      },
      externalid: {
        maxLength: maxLength(64)
      },
      type: {
        decimal,
        maxValue: maxValue(255)
      }

    }
  },
  computed: {
    gasConversionPreview () {
      const f = this.addEmissionForm
      if (f.typeKey !== 'gas' || f.gasInputUnit !== 'kWh') return ''
      const factor = kwhPerCubicMeter(f.calorificValue, f.stateNumber)
      if (!factor) return ''
      const fmt = (n, d) => Number(n).toLocaleString('de-DE', { maximumFractionDigits: d })
      const co2e = perKwhToPerCubicMeter(f.co2e, factor)
      const price = perKwhToPerCubicMeter(f.unitPrice, factor)
      return this.$t('editFacilityModal.gasConversionPreview', {
        factor: fmt(factor, 4),
        co2e: (co2e === '' || co2e === null) ? '–' : fmt(co2e, 6),
        price: (price === '' || price === null) ? '–' : fmt(price, 4)
      })
    },
    createMapLink () {
      if (this.facility && this.facility.geolatitude && this.facility.geolongitude) {
        return 'http://maps.apple.com/?ll=' + this.facility.geolatitude + ',' + this.facility.geolongitude
      }
      return ''
    },
    supplyContracts () {
      return this.$store.getters.supplyContracts
    },
    isAdmin () {
      return this.$store.getters.client && this.$store.getters.client.role === 4
    },
    canMoveFacility () {
      return this.isAdmin && this.action === 'edit' && this.organizationOptions.length > 1
    },
    organizationOptions () {
      return [...this.organizationList].sort((a, b) => a.name.localeCompare(b.name))
    },
    organizationChanged () {
      return this.canMoveFacility && this.targetOrganizationId !== null && this.targetOrganizationId !== this.facility.organizationid
    },
    targetOrganizationName () {
      const target = this.organizationList.find(o => o.id === this.targetOrganizationId)
      return target ? target.name : ''
    },
    hasAnyRecalcEmission () {
      return Object.values(this.recalcEmissionsMap).some(e => e !== null)
    }
  },
  mounted () {
    document.getElementById('editFacilityModal').addEventListener('shown.bs.modal', () => {
      this.triggerFocus()
    })
  },
  methods: {
    copyFacility () {
      this.facility = Object.assign({}, this.selectedFacility)
      this.targetOrganizationId = this.facility.organizationid ?? null
      if (this.facility.extra == null) {
        /* eslint-disable no-console */
        console.log('add extra')
        this.extra = {}
      } else {
        this.extra = Object.assign({}, JSON.parse(this.facility.extra))
      }
    },
    loadOrganizationList () {
      organizationService.getOrganizationData().then(data => {
        this.organizationList = data.organizations || []
      }).catch(() => {
        this.organizationList = []
      })
    },
    loadFacilityEmissions () {
      facilityService.getEmissions(this.selectedFacility.id).then(data => {
        this.facilityEmissions = data.emissions || []
        this.emissionUsage = data.emissionUsage || {}
      }).catch(() => {
        this.facilityEmissions = []
        this.emissionUsage = {}
      })
      this.loadFacilityCoverage()
    },
    loadFacilityCoverage () {
      coverageService.facilityCoverage(this.selectedFacility.id).then(data => {
        this.facilityCoverage = data.coverage || []
      }).catch(() => {
        this.facilityCoverage = []
      })
    },
    coverageRow (typeKey) {
      const type = this.emissionSensorTypes[typeKey]
      return this.facilityCoverage.find(r => r.type === type) || null
    },
    // the coverage row when there is something to do for this medium, else null
    coverageGap (typeKey) {
      const row = this.coverageRow(typeKey)
      return (row && isCoverageGap(row)) ? row : null
    },
    coverageUnassigned (typeKey) {
      const row = this.coverageRow(typeKey)
      return row ? unassignedCount(row) : 0
    },
    coveragePeriod (typeKey) {
      const row = this.coverageRow(typeKey)
      if (!row || !row.firstDay) return ''
      const from = moment(row.firstDay).format('DD.MM.YYYY')
      const to = moment(row.lastDay).format('DD.MM.YYYY')
      return from === to ? from : from + ' – ' + to
    },
    fixCoverage (typeKey) {
      this.coverageFixing = typeKey
      this.coverageMessage[typeKey] = null
      coverageService.fix(this.selectedFacility.id, this.emissionSensorTypes[typeKey], null).then(data => {
        this.coverageMessage[typeKey] = {
          ok: true,
          text: this.$t(data.created ? 'editFacilityModal.coverageResultCreated' : 'editFacilityModal.coverageResultStamped', { processed: data.processed })
        }
        this.loadFacilityEmissions()
      }).catch(error => {
        // no template chooser in this dialog: point to "Neue Emission" instead
        const text = error.message === 'No unique supply contract for type'
          ? this.$t('editFacilityModal.coverageNoUniqueTemplate')
          : this.localizedBackendMessage(error.message)
        this.coverageMessage[typeKey] = { ok: false, text }
      }).finally(() => {
        this.coverageFixing = null
      })
    },
    emissionUsageCount (emissionId) {
      // emissionUsage keys are JSON-string ids; coerce for the lookup.
      const v = this.emissionUsage[emissionId] != null
        ? this.emissionUsage[emissionId]
        : this.emissionUsage[String(emissionId)]
      return v != null ? v : 0
    },
    canDeleteEmission (emission) {
      return emission && !emission.active && this.emissionUsageCount(emission.id) === 0
    },
    confirmDeleteEmission (emission) {
      if (!this.canDeleteEmission(emission)) return
      const summary = [
        emission.co2e + ' kg',
        emission.validFrom ? this.formatEmissionDate(emission.validFrom) : '?',
        emission.description || ''
      ].filter(s => s !== '').join(' · ')
      // Browser-level confirm is good enough — admin-only, low-frequency.
      if (window.confirm(this.$t('editFacilityModal.emissionDeleteConfirm', { summary }))) {
        facilityService.deleteEmission(emission.id).then(() => {
          this.loadFacilityEmissions()
        }).catch(error => {
          this.errorMessage = this.localizedBackendMessage ? this.localizedBackendMessage(error.message) : (error.message || 'Failed')
        })
      }
    },
    activeEmissionForType (typeKey) {
      const sensorType = this.emissionSensorTypes[typeKey]
      return this.facilityEmissions.find(e => e.active && e.emissionType && e.emissionType.type === sensorType) || null
    },
    historicalEmissionsForType (typeKey) {
      const sensorType = this.emissionSensorTypes[typeKey]
      return this.facilityEmissions
        .filter(e => !e.active && e.emissionType && e.emissionType.type === sensorType)
        .slice()
        .sort((a, b) => {
          const av = a.validFrom ? new Date(a.validFrom).getTime() : 0
          const bv = b.validFrom ? new Date(b.validFrom).getTime() : 0
          return bv - av
        })
    },
    toggleHistory (typeKey) {
      this.historyOpenForType = this.historyOpenForType === typeKey ? null : typeKey
    },
    formatPrice (value, digits = 2) {
      if (value == null || value === '') return '—'
      const n = Number(value)
      if (Number.isNaN(n)) return value
      return n.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits })
    },
    isEditingDescription (emissionId) {
      return this.descEditState != null && this.descEditState.emissionId === emissionId
    },
    startEditDescription (emission) {
      this.descEditState = {
        emissionId: emission.id,
        value: emission.description || '',
        errorMessage: '',
        saving: false
      }
    },
    cancelEditDescription () {
      this.descEditState = null
    },
    saveDescriptionEdit () {
      if (!this.descEditState) return
      const state = this.descEditState
      state.saving = true
      state.errorMessage = ''
      facilityService.updateEmissionDescription(state.emissionId, state.value).then(() => {
        // Patch the local list so the UI updates without a full reload.
        const target = this.facilityEmissions.find(e => e.id === state.emissionId)
        if (target) target.description = state.value
        this.descEditState = null
      }).catch(error => {
        state.errorMessage = this.localizedBackendMessage ? this.localizedBackendMessage(error.message) : (error.message || 'Failed')
        state.saving = false
      })
    },
    supplyContractsForType (typeKey) {
      const sensorType = this.emissionSensorTypes[typeKey]
      return this.supplyContracts.filter(sc => sc.scope === sensorType)
    },
    // unit the user types in: gas may be entered per kWh (gas bill) and is
    // converted to m³ on save, everything else is entered in the stored unit
    inputUnit (typeKey) {
      return (typeKey === 'gas' && this.addEmissionForm.gasInputUnit === 'kWh') ? 'kWh' : this.emissionUnit(typeKey)
    },
    emissionUnit (typeKey) {
      // must match the backend (CDCDeviceManagement.applyCo2e/applyCost): Wh
      // registers (power, heat) are converted to kWh, volume (gas, water) stays m³
      return (typeKey === 'power' || typeKey === 'heat') ? 'kWh' : 'm³'
    },
    capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    openAddEmission (typeKey, context = 'facility') {
      this.addEmissionForm = { typeKey, context, supplyContractId: null, co2e: '', basePrice: '', unitPrice: '', description: '', validFrom: '', validTill: '', errorMessage: '', gasInputUnit: 'm3', calorificValue: '', stateNumber: '' }
      // start from the standard template of the medium (can be switched to "manuell")
      const standard = defaultContractForType(this.supplyContracts, this.emissionSensorTypes[typeKey])
      if (standard) {
        this.addEmissionForm.supplyContractId = standard.id
        this.prefillFromContract()
      }
    },
    closeAddEmission () {
      this.addEmissionForm = { typeKey: null, context: 'facility', supplyContractId: null, co2e: '', basePrice: '', unitPrice: '', description: '', validFrom: '', validTill: '', errorMessage: '', gasInputUnit: 'm3', calorificValue: '', stateNumber: '' }
    },
    prefillFromContract () {
      if (this.addEmissionForm.supplyContractId) {
        const sc = this.supplyContracts.find(s => s.id === this.addEmissionForm.supplyContractId)
        if (sc) {
          this.addEmissionForm.co2e = sc.co2e
          this.addEmissionForm.basePrice = sc.basePrice != null ? sc.basePrice : ''
          this.addEmissionForm.unitPrice = sc.unitPrice != null ? sc.unitPrice : ''
          this.addEmissionForm.description = sc.contractName
          // templates are stored in the meter unit (m³ for gas)
          this.addEmissionForm.gasInputUnit = 'm3'
        }
      } else {
        this.addEmissionForm.co2e = ''
        this.addEmissionForm.basePrice = ''
        this.addEmissionForm.unitPrice = ''
        this.addEmissionForm.description = ''
      }
    },
    saveEmission () {
      this.addEmissionForm.errorMessage = ''
      const typeKey = this.addEmissionForm.typeKey
      const context = this.addEmissionForm.context
      const emissionTypeId = this.emissionSensorTypes[typeKey]
      let co2e = this.addEmissionForm.co2e
      let unitPrice = this.addEmissionForm.unitPrice
      let description = this.addEmissionForm.description
      if (typeKey === 'gas' && this.addEmissionForm.gasInputUnit === 'kWh') {
        const factor = kwhPerCubicMeter(this.addEmissionForm.calorificValue, this.addEmissionForm.stateNumber)
        if (!factor) {
          this.addEmissionForm.errorMessage = this.$t('editFacilityModal.gasConversionInvalid')
          return
        }
        const note = conversionNote(co2e, this.addEmissionForm.calorificValue, this.addEmissionForm.stateNumber)
        co2e = perKwhToPerCubicMeter(co2e, factor)
        unitPrice = perKwhToPerCubicMeter(unitPrice, factor)
        description = (description ? description + ' – ' : '') + note
      }
      const payload = {
        co2e,
        emissionTypeId,
        supplyContractId: this.addEmissionForm.supplyContractId || null,
        description: description ? description.slice(0, 1024) : null,
        validFrom: this.addEmissionForm.validFrom || null,
        validTill: this.addEmissionForm.validTill || null,
        basePrice: this.addEmissionForm.basePrice !== '' ? this.addEmissionForm.basePrice : 0,
        unitPrice: unitPrice !== '' && unitPrice !== null ? unitPrice : 0,
        isDynamic: false
      }
      facilityService.addEmission(this.facility.id, payload).then(() => {
        this.closeAddEmission()
        this.loadFacilityEmissions()
        if (context === 'recalc') {
          this.loadRecalcEmissions()
        }
      }).catch(error => {
        this.addEmissionForm.errorMessage = error.message
      })
    },
    saveFacility () {
      this.v$.$touch()
      if (this.v$.$invalid) {
        return
      }
      if (Object.keys(this.extra).length) {
        this.facility.extra = this.extra
      }
      if (this.action === 'add') {
        facilityService.addFacility(this.facility).then((createdFacility) => {
          this.flagChanges()
        }).catch(error => {
          this.errorMessage = this.localizedBackendMessage(error.message)
        })
      } else if (this.action === 'edit') {
        // the organization is not part of the update payload's editable fields —
        // a changed organization goes through the dedicated move endpoint afterwards
        const moveTo = this.organizationChanged ? this.targetOrganizationId : null
        facilityService.updateFacility(this.facility.id, this.facility).then(() => {
          return moveTo !== null ? facilityService.moveFacility(this.facility.id, moveTo) : null
        }).then(() => {
          this.flagChanges()
        }).catch(error => {
          this.errorMessage = this.localizedBackendMessage(error.message)
        })
      }
    },
    close () {
      this.v$.$reset()
      this.errorMessage = ''
      // zurück zum ursprünglichen 'selected facility',
      // um etwaigen Änderungen im Formular loszuwerden
      this.copyFacility()
      //
      // this.$refs.facilityEditForm.reset()
      this.emitClosed()
      Modal.getInstance(document.getElementById('editFacilityModal'))?.hide()
    },
    triggerFocus () {
      document.getElementById('nameInput')?.focus()
    },
    checkType () {
      //
    },
    facilityTypeString (type) {
      return this.attributeLabelForCode('facilityTypes', type)
    },
    addFluksData () {
      this.extra.fluks = {}
      this.$forceUpdate()
    },
    loadRecalcEmissions () {
      this.recalcMessage = ''
      this.recalcError = false
      this.recalcShowPanel = false
      this.recalcEmissionsMap = {}
      this.recalcAllEmissions = []
      this.recalcPickerTypeKey = null
      facilityService.getEmissions(this.selectedFacility.id).then(data => {
        const allEmissions = data.emissions || []
        this.recalcAllEmissions = allEmissions
        const fromDate = new Date(this.recalcFrom)
        fromDate.setHours(0, 0, 0, 0)
        const toDate = new Date(this.recalcTo)
        toDate.setHours(23, 59, 59, 999)
        const newMap = {}
        Object.keys(this.emissionSensorTypes).forEach(typeKey => {
          const sensorType = this.emissionSensorTypes[typeKey]
          // Include all emissions overlapping [recalcFrom, recalcTo]:
          // started before range end AND not expired before range start (null = open-ended)
          const candidates = allEmissions.filter(e => {
            const eType = e.emissionType ? e.emissionType.type : e.type
            if (eType !== sensorType) return false
            if (e.validTill && new Date(e.validTill) < fromDate) return false
            if (e.validFrom && new Date(e.validFrom) > toDate) return false
            return true
          })
          // Auto-select: latest validFrom that started on or before recalcFrom; fall back to first candidate
          const atStart = candidates.filter(e => !e.validFrom || new Date(e.validFrom) <= fromDate)
          const best = atStart.length > 0
            ? atStart.reduce((prev, curr) => {
              const prevTime = prev.validFrom ? new Date(prev.validFrom).getTime() : 0
              const currTime = curr.validFrom ? new Date(curr.validFrom).getTime() : 0
              return currTime >= prevTime ? curr : prev
            })
            : (candidates.length > 0 ? candidates[0] : null)
          newMap[typeKey] = best || null
        })
        this.recalcEmissionsMap = newMap
        this.recalcShowPanel = true
      }).catch(() => {
        this.recalcShowPanel = true
      })
    },
    recalcEmissionForType (typeKey) {
      return this.recalcEmissionsMap[typeKey] || null
    },
    recalcCandidatesForType (typeKey) {
      const sensorType = this.emissionSensorTypes[typeKey]
      const fromDate = new Date(this.recalcFrom)
      fromDate.setHours(0, 0, 0, 0)
      const toDate = new Date(this.recalcTo)
      toDate.setHours(23, 59, 59, 999)
      return this.recalcAllEmissions.filter(e => {
        const eType = e.emissionType ? e.emissionType.type : e.type
        if (eType !== sensorType) return false
        if (e.validTill && new Date(e.validTill) < fromDate) return false
        if (e.validFrom && new Date(e.validFrom) > toDate) return false
        return true
      })
    },
    openRecalcPicker (typeKey) {
      this.recalcPickerTypeKey = this.recalcPickerTypeKey === typeKey ? null : typeKey
    },
    selectRecalcEmission (typeKey, emission) {
      this.recalcEmissionsMap = { ...this.recalcEmissionsMap, [typeKey]: emission }
      this.recalcPickerTypeKey = null
    },
    resetRecalcPanel () {
      this.recalcShowPanel = false
      this.recalcEmissionsMap = {}
      this.recalcAllEmissions = []
      this.recalcPickerTypeKey = null
      this.recalcMessage = ''
      this.recalcError = false
    },
    formatEmissionDate (ts) {
      if (!ts) return '∞'
      return new Date(ts).toLocaleDateString(navigator.language)
    },
    triggerRecalculate () {
      this.recalcMessage = ''
      this.recalcError = false
      this.recalcLoading = true
      // Build sensorType(int) -> emissionId map from user's selection
      const emissionOverrides = {}
      Object.keys(this.recalcEmissionsMap).forEach(typeKey => {
        const em = this.recalcEmissionsMap[typeKey]
        if (em && em.id != null) {
          emissionOverrides[this.emissionSensorTypes[typeKey]] = em.id
        }
      })
      facilityService.recalculateCo2e(this.facility.id, this.recalcFrom, this.recalcTo, emissionOverrides).then(response => {
        const processed = response.processed != null ? response.processed : '?'
        const skipped = response.skipped && response.skipped.length > 0
          ? ' ' + this.$t('editFacilityModal.recalculateSkipped') + ': ' + response.skipped.join(', ')
          : ''
        this.recalcMessage = this.$t('editFacilityModal.recalculateSuccess') + ' (' + processed + ' ' + this.$t('editFacilityModal.recalculateEntries') + ')' + skipped
      }).catch(error => {
        this.recalcError = true
        this.recalcMessage = error.message
      }).finally(() => {
        this.recalcLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  .modal-dialog {
    width: 520px;
  }

  .blue-text {
    color: #0069d9;
    font-weight: 700;
  }

  .td-right {
    text-align: right;
  }
}

.emission-active {
  background: #f0fff4;
  border-left: 3px solid #28a745;
  border-radius: 3px;
  padding: 6px 8px;
  margin-top: 4px;
}
.emission-row {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 1px 0;
}
.coverage-warning {
  background: #fff4e5;
  border-left: 3px solid #ff8000;
  padding: 4px 8px;
  border-radius: 3px;
}
.emission-label {
  min-width: 110px;
  color: #6c757d;
}
.description-row {
  flex-wrap: wrap;
}
.description-value {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.description-edit-icon {
  cursor: pointer;
  color: #6c757d;
  font-size: 12px;
  &:hover { color: #0069d9; }
}
.description-edit {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 1 1 auto;
}
.description-input {
  display: inline-block;
  width: auto;
  flex: 1 1 200px;
  min-width: 200px;
}
.description-btn {
  padding: 2px 8px;
  font-size: 12px;
}
.emission-history {
  border-top: 1px dashed #dee2e6;
  padding-top: 4px;
}
.history-toggle {
  text-decoration: none;
  &:hover { text-decoration: underline; }
}
.emission-history-list {
  background: #fafafa;
  border-radius: 3px;
  padding: 4px 8px;
}
.emission-history-row {
  padding: 4px 0;
  border-bottom: 1px solid #eee;
  &:last-child { border-bottom: none; }
}
.emission-history-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}
.emission-history-text {
  flex: 1 1 auto;
  min-width: 0;
}
.emission-delete-btn {
  padding: 0 4px;
  color: #adb5bd;
  flex: 0 0 auto;
  &:hover { color: #dc3545; }
}
</style>
